const nextMapRouteBase = '/next'

type MapChildRoute = 'cards' | 'data' | 'dialog' | 'layers'
const mapCollectionPathnames = new Set(['/', '/cards', '/data', '/layers'])

function appendSearch(pathname: string, search = '') {
  if (!search) return pathname
  return `${pathname}${search.startsWith('?') ? search : `?${search}`}`
}

function withMapRouteBase(base: string, suffix = '') {
  if (!base) return suffix || '/'
  return suffix ? `${base}${suffix}` : base
}

export function getMapRouteBase(pathname: string) {
  return pathname === nextMapRouteBase ||
    pathname.startsWith(`${nextMapRouteBase}/`)
    ? nextMapRouteBase
    : ''
}

export function getMapRoutePathname(pathname: string) {
  const base = getMapRouteBase(pathname)
  if (!base) return pathname

  return pathname.slice(base.length) || '/'
}

export function isMapCollectionPathname(pathname: string) {
  return mapCollectionPathnames.has(getMapRoutePathname(pathname))
}

export function buildMapRootPath(pathname: string, search = '') {
  return appendSearch(withMapRouteBase(getMapRouteBase(pathname)), search)
}

export function buildMapChildPath(
  pathname: string,
  childRoute: Exclude<MapChildRoute, 'dialog'>,
  search = ''
) {
  return appendSearch(
    withMapRouteBase(getMapRouteBase(pathname), `/${childRoute}`),
    search
  )
}

export function buildMapListingPath(
  pathname: string,
  slug: string,
  search = '',
  childRoute?: Exclude<MapChildRoute, 'layers'>
) {
  const childSuffix = childRoute ? `/${childRoute}` : ''
  return appendSearch(
    withMapRouteBase(getMapRouteBase(pathname), `/${slug}${childSuffix}`),
    search
  )
}
